$ ->
  
  $(document).on 'click', '[data-collapse-all]', (e) ->
    self = $ e.currentTarget
    action = self.attr('data-collapse-all').toLowerCase()
    target = $ self.attr 'data-target'
    if target.length
      if action is 'collapse'
        target.find('.collapse').collapse('hide')
      else if action is 'expand'
        target.find('.collapse').collapse('show')